/* Context + Provider を同ファイルにまとめる（Fast Refresh 用ルールの例外） */
/* eslint-disable react-refresh/only-export-components */
import { type ReactNode, createContext, useCallback, useMemo, useState } from "react";
import {
  BRAND_PATTERNS,
  DEFAULT_BRAND_PATTERN_INDEX,
  persistBrandPatternIndex,
  readSavedBrandPatternIndex,
  type BrandPattern,
} from "@/constants/brandPattern";

export type BrandPatternContextValue = {
  patternIndex: number;
  setPatternIndex: (i: number) => void;
  pattern: BrandPattern;
};

export const BrandPatternContext = createContext<BrandPatternContextValue | null>(null);

export function BrandPatternProvider({ children }: { children: ReactNode }) {
  const [patternIndex, setIndexState] = useState(() => readSavedBrandPatternIndex());

  const setPatternIndex = useCallback((i: number) => {
    const c = Math.max(0, Math.min(BRAND_PATTERNS.length - 1, Math.floor(i)));
    setIndexState(c);
    persistBrandPatternIndex(c);
  }, []);

  const pattern = BRAND_PATTERNS[patternIndex] ?? BRAND_PATTERNS[DEFAULT_BRAND_PATTERN_INDEX];

  const value = useMemo<BrandPatternContextValue>(
    () => ({
      patternIndex,
      setPatternIndex,
      pattern,
    }),
    [patternIndex, setPatternIndex, pattern],
  );

  return <BrandPatternContext.Provider value={value}>{children}</BrandPatternContext.Provider>;
}
